// 确保 Flickity 可用，若未加载则动态引入
if (typeof Flickity === 'undefined') {
  const script = document.createElement('script');
  script.src = 'https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js';
  script.onload = initCarousels;
  document.head.appendChild(script);

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://unpkg.com/flickity@2/dist/flickity.min.css';
  document.head.appendChild(link);
} else {
  initCarousels();
}

function initCarousels() {
  const carousels = document.querySelectorAll('.fh-carousel');
  carousels.forEach(el => {
    if (el.flickity) return;
    const options = el.dataset.flickity ? JSON.parse(el.dataset.flickity) : {};
    new Flickity(el, options);
  });
}

// 支持 Shopify 主题编辑器动态加载
document.addEventListener('shopify:section:load', (e) => {
  const section = e.target;
  const carousel = section.querySelector('.fh-carousel');
  if (carousel && typeof Flickity !== 'undefined') {
    const options = carousel.dataset.flickity ? JSON.parse(carousel.dataset.flickity) : {};
    new Flickity(carousel, options);
  }
});

document.addEventListener('shopify:section:unload', (e) => {
  const section = e.target;
  const carousel = section.querySelector('.fh-carousel');
  if (carousel && carousel.flickity) {
    carousel.flickity.destroy();
  }
});